// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*------------------------------------
  Estilos generales de formulario y botones
------------------------------------*/
.form-input {
  width: 150px;
  height: 30px;
  box-sizing: border-box;
}

.Button {
  height: 38px !important;
}

.btn-primary-modals-maestros {
  background-color: #006699;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.btn-primary-modals-maestros:hover {
  background-color: #005580;
}



/*------------------------------------
  Card contenedor de la tabla
------------------------------------*/
.card.ContainerTableMaestros {
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden; /* oculta cualquier desborde fuera del card */
}

/* clase que aplicamos dinámicamente */
.card-selected {
  background-color: #f0f0f0 !important;
}

.card-fixed {
  width: 100%;
  transition: transform .2s;
}

/* en pantallas lg+ fuerza 200px */
@media (min-width: 992px) {
  .card-fixed {
    width: 148px;
    flex: 0 0 auto;
  }
}

.crearContratoControlDevice {
  margin-bottom: 12px;
}

/* opcional: resaltado */
.card-fixed.card-selected {
  transform: scale(1.05);
}


/*------------------------------------
  Wrapper con scroll vertical + horizontal
------------------------------------*/
.ContainerTableMaestros .table-responsive {
  display: block;        /* hace que overflow-x funcione */
  width: 100%;           /* ocupa todo el card */
  max-height: 300px;     /* scroll vertical */
  overflow-y: auto;
  overflow-x: auto;      /* scroll horizontal interno */
  -webkit-overflow-scrolling: touch;
  position: relative;    /* referencia para thead sticky */
  white-space: normal !important; /* anula cualquier nowrap heredado */
}

/*------------------------------------
  Tabla base
------------------------------------*/
.ContainerTableMaestros table {
  border-collapse: collapse;
  width: auto;           /* ancho según contenido */
  min-width: 600px;      /* ajusta: suma mínima de anchos de columna */
}

/*------------------------------------
  Encabezado fijo
------------------------------------*/
.ContainerTableMaestros thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #006699;
  color: #fff;
  padding: .75rem;
  white-space: nowrap;   /* que el header no envuelva */
}

/*------------------------------------
  Anchos de columna (ajusta a tu gusto)
------------------------------------*/
.ContainerTableMaestros th:nth-child(1),
.ContainerTableMaestros td:nth-child(1) {
  width: 400px;   /* Descripción */
}
.ContainerTableMaestros th:nth-child(2),
.ContainerTableMaestros td:nth-child(2) {
  width: 100px;   /* Km */
  text-align: center;
}
.ContainerTableMaestros th:nth-child(3),
.ContainerTableMaestros td:nth-child(3) {
  width: 100px;   /* Acciones */
  text-align: center;
}

/*------------------------------------
  Celdas: forzar nowrap para disparar scroll-x
------------------------------------*/
.ContainerTableMaestros th,
.ContainerTableMaestros td {
  white-space: nowrap;
  padding: .75rem;
}


/* Icono: escala entre 1.6rem y 2.6rem según el viewport */
.maestro-icon {
  line-height: 1;
  font-size: clamp(1.6rem, 1.1rem + 1.2vw, 2.6rem);
}

/* Título: legible en todas las resoluciones, con elipsis si es largo */
.maestro-title {
  display: block;
  font-weight: 700;
  font-size: clamp(0.8rem, 0.6rem + 0.4vw, 1rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Ajuste fino para ≥1280px (8 cards en línea) */
@media (min-width: 1280px) {
  .maestro-icon  { font-size: 2.2rem; }   /* estable/consistente en desktop ancho */
  .maestro-title { font-size: 0.8rem; }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/modalesMaestros.css"],"names":[],"mappings":"AAAA;;qCAEqC;AACrC;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;;;AAIA;;qCAEqC;AACrC;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;AACxB;;;AAGA;;qCAEqC;AACrC;EACE,cAAc,SAAS,iCAAiC;EACxD,WAAW,YAAY,uBAAuB;EAC9C,iBAAiB,MAAM,oBAAoB;EAC3C,gBAAgB;EAChB,gBAAgB,OAAO,8BAA8B;EACrD,iCAAiC;EACjC,kBAAkB,KAAK,iCAAiC;EACxD,8BAA8B,EAAE,oCAAoC;AACtE;;AAEA;;qCAEqC;AACrC;EACE,yBAAyB;EACzB,WAAW,YAAY,0BAA0B;EACjD,gBAAgB,OAAO,6CAA6C;AACtE;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB,IAAI,8BAA8B;AACvD;;AAEA;;qCAEqC;AACrC;;EAEE,YAAY,IAAI,gBAAgB;AAClC;AACA;;EAEE,YAAY,IAAI,OAAO;EACvB,kBAAkB;AACpB;AACA;;EAEE,YAAY,IAAI,aAAa;EAC7B,kBAAkB;AACpB;;AAEA;;qCAEqC;AACrC;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;;AAGA,0DAA0D;AAC1D;EACE,cAAc;EACd,gDAAgD;AAClD;;AAEA,uEAAuE;AACvE;EACE,cAAc;EACd,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,iBAAiB,iBAAiB,EAAE,IAAI,yCAAyC;EACjF,iBAAiB,iBAAiB,EAAE;AACtC","sourcesContent":["/*------------------------------------\n  Estilos generales de formulario y botones\n------------------------------------*/\n.form-input {\n  width: 150px;\n  height: 30px;\n  box-sizing: border-box;\n}\n\n.Button {\n  height: 38px !important;\n}\n\n.btn-primary-modals-maestros {\n  background-color: #006699;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.btn-primary-modals-maestros:hover {\n  background-color: #005580;\n}\n\n\n\n/*------------------------------------\n  Card contenedor de la tabla\n------------------------------------*/\n.card.ContainerTableMaestros {\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden; /* oculta cualquier desborde fuera del card */\n}\n\n/* clase que aplicamos dinámicamente */\n.card-selected {\n  background-color: #f0f0f0 !important;\n}\n\n.card-fixed {\n  width: 100%;\n  transition: transform .2s;\n}\n\n/* en pantallas lg+ fuerza 200px */\n@media (min-width: 992px) {\n  .card-fixed {\n    width: 148px;\n    flex: 0 0 auto;\n  }\n}\n\n.crearContratoControlDevice {\n  margin-bottom: 12px;\n}\n\n/* opcional: resaltado */\n.card-fixed.card-selected {\n  transform: scale(1.05);\n}\n\n\n/*------------------------------------\n  Wrapper con scroll vertical + horizontal\n------------------------------------*/\n.ContainerTableMaestros .table-responsive {\n  display: block;        /* hace que overflow-x funcione */\n  width: 100%;           /* ocupa todo el card */\n  max-height: 300px;     /* scroll vertical */\n  overflow-y: auto;\n  overflow-x: auto;      /* scroll horizontal interno */\n  -webkit-overflow-scrolling: touch;\n  position: relative;    /* referencia para thead sticky */\n  white-space: normal !important; /* anula cualquier nowrap heredado */\n}\n\n/*------------------------------------\n  Tabla base\n------------------------------------*/\n.ContainerTableMaestros table {\n  border-collapse: collapse;\n  width: auto;           /* ancho según contenido */\n  min-width: 600px;      /* ajusta: suma mínima de anchos de columna */\n}\n\n/*------------------------------------\n  Encabezado fijo\n------------------------------------*/\n.ContainerTableMaestros thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #006699;\n  color: #fff;\n  padding: .75rem;\n  white-space: nowrap;   /* que el header no envuelva */\n}\n\n/*------------------------------------\n  Anchos de columna (ajusta a tu gusto)\n------------------------------------*/\n.ContainerTableMaestros th:nth-child(1),\n.ContainerTableMaestros td:nth-child(1) {\n  width: 400px;   /* Descripción */\n}\n.ContainerTableMaestros th:nth-child(2),\n.ContainerTableMaestros td:nth-child(2) {\n  width: 100px;   /* Km */\n  text-align: center;\n}\n.ContainerTableMaestros th:nth-child(3),\n.ContainerTableMaestros td:nth-child(3) {\n  width: 100px;   /* Acciones */\n  text-align: center;\n}\n\n/*------------------------------------\n  Celdas: forzar nowrap para disparar scroll-x\n------------------------------------*/\n.ContainerTableMaestros th,\n.ContainerTableMaestros td {\n  white-space: nowrap;\n  padding: .75rem;\n}\n\n\n/* Icono: escala entre 1.6rem y 2.6rem según el viewport */\n.maestro-icon {\n  line-height: 1;\n  font-size: clamp(1.6rem, 1.1rem + 1.2vw, 2.6rem);\n}\n\n/* Título: legible en todas las resoluciones, con elipsis si es largo */\n.maestro-title {\n  display: block;\n  font-weight: 700;\n  font-size: clamp(0.8rem, 0.6rem + 0.4vw, 1rem);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n/* Ajuste fino para ≥1280px (8 cards en línea) */\n@media (min-width: 1280px) {\n  .maestro-icon  { font-size: 2.2rem; }   /* estable/consistente en desktop ancho */\n  .maestro-title { font-size: 0.8rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
